// extracted by mini-css-extract-plugin
export var container_footer = "PreguntasFrecuentasCafetera-module--container_footer--a4d3e";
export var container_preguntas = "PreguntasFrecuentasCafetera-module--container_preguntas--0e867";
export var container_section = "PreguntasFrecuentasCafetera-module--container_section--58698";